import React from 'react';

import type CK from '~/types/contentking';

import {
	usePlatformIssueCategoriesLazyQuery,
} from './usePlatformIssueCategories.gql';



function useReloadPlatformIssueCategories(websiteId: CK.WebsiteId | null) {
	const [reloadPlatformIssueCategories] = usePlatformIssueCategoriesLazyQuery({
		fetchPolicy: 'cache-and-network',
	});

	return React.useCallback(
		async () => {
			if (websiteId === null) {
				return;
			}

			await reloadPlatformIssueCategories({
				variables: {
					websiteId,
				},
			});
		},
		[
			reloadPlatformIssueCategories,
			websiteId,
		],
	);
}



export default useReloadPlatformIssueCategories;
